module.exports = __webpack_public_path__ + "img/4febdf7.webp";